@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;


.link {
	font-weight: normal;
	color: Colors.$col-blue;
	text-decoration: underline;
}


.modal-header {
	padding-bottom: Constants.$val-spacing-l;
}

.radio-option {
	margin-bottom: Constants.$val-spacing-s;
}

.pdf {
	display: flex;
	justify-content: center;
}